'use client'

import { motion } from 'framer-motion'
import { Space_Grotesk, Outfit } from 'next/font/google'
import { BackgroundBeams } from '../../_components/_ui/background-beams'

const spaceGrotesk = Space_Grotesk({ 
  subsets: ['latin'],
  variable: '--font-space-grotesk',
  display: 'swap'
})

const outfit = Outfit({ 
  subsets: ['latin'],
  variable: '--font-outfit',
  display: 'swap'
})

const Cookies = () => {
    return (
        <div className="min-h-screen w-full relative">
            <BackgroundBeams />
            <div className="relative z-10">
                {/* Hero Section */}
                <div className="pt-16 pb-8 px-4 sm:px-6 lg:px-8">
                    <div className="max-w-3xl mx-auto">
                        <motion.h1 
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            className="font-space-grotesk text-2xl sm:text-3xl font-bold text-white leading-tight"
                        >
                            Cookie Policy
                        </motion.h1>
                        <motion.p 
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.1 }}
                            className="text-sm text-gray-400 mt-2"
                        >
                            Effective Date: {new Date().toLocaleDateString()}
                        </motion.p>
                    </div>
                </div>

                {/* Main Content */}
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                        className="bg-neutral-900/50 backdrop-blur-sm rounded-2xl p-8 border border-neutral-800 prose prose-invert max-w-none"
                    >
                        <section className="mb-8">
                            <h2 className="text-lg font-semibold text-white mb-4">1. DEFINITIONS AND INTERPRETATION</h2>
                            <p className="text-sm text-gray-300 leading-relaxed mb-4">
                                1.1. "Cookie" means a small text file placed on your device that enables various features and functionality of our Service.
                            </p>
                            <p className="text-sm text-gray-300 leading-relaxed">
                                1.2. "Service" refers to the Autofoc.us platform and associated services.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-lg font-semibold text-white mb-4">2. IMPLEMENTATION OF COOKIES</h2>
                            <p className="text-sm text-gray-300 leading-relaxed mb-4">
                                2.1. Our Service employs cookies and similar tracking technologies strictly for the following purposes:
                            </p>
                            <ul className="text-sm text-gray-300 list-disc pl-6 space-y-2 mb-4">
                                <li>Authentication and security of user sessions</li>
                                <li>Basic functionality and navigation</li>
                                <li>User preferences and settings retention</li>
                                <li>Anonymous analytics data collection</li>
                            </ul>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-lg font-semibold text-white mb-4">3. CATEGORIES OF COOKIES</h2>
                            
                            <h3 className="text-base font-medium text-gray-200 mb-2">3.1. Essential Cookies</h3>
                            <p className="text-sm text-gray-300 leading-relaxed mb-4">
                                These cookies are strictly necessary for the operation of our Service and cannot be disabled without severely affecting site functionality.
                            </p>

                            <h3 className="text-base font-medium text-gray-200 mb-2">3.2. Analytical Cookies</h3>
                            <p className="text-sm text-gray-300 leading-relaxed mb-4">
                                We utilize analytical cookies to gather anonymous statistical data about Service usage patterns and performance metrics.
                            </p>

                            <h3 className="text-base font-medium text-gray-200 mb-2">3.3. Functionality Cookies</h3>
                            <p className="text-sm text-gray-300 leading-relaxed mb-4">
                                These cookies enable enhanced user experience through preference retention and customized content delivery.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-lg font-semibold text-white mb-4">4. THIRD-PARTY COOKIES</h2>
                            <p className="text-sm text-gray-300 leading-relaxed mb-4">
                                4.1. Our Service integrates with third-party services that may implement their own cookies, including but not limited to:
                            </p>
                            <ul className="text-sm text-gray-300 list-disc pl-6 space-y-2">
                                <li>Google Analytics for anonymous usage statistics</li>
                                <li>Authentication service providers</li>
                                <li>Content delivery networks</li>
                            </ul>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-lg font-semibold text-white mb-4">5. COOKIE MANAGEMENT</h2>
                            <p className="text-sm text-gray-300 leading-relaxed">
                                5.1. Users maintain the right to modify their cookie preferences through their browser settings. Please note that restricting cookies may impact Service functionality.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-lg font-semibold text-white mb-4">6. UPDATES TO THIS POLICY</h2>
                            <p className="text-sm text-gray-300 leading-relaxed">
                                6.1. We reserve the right to modify this Cookie Policy at any time. Changes will be effective immediately upon posting to the Service.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-lg font-semibold text-white mb-4">7. CONTACT INFORMATION</h2>
                            <p className="text-sm text-gray-300 leading-relaxed">
                                For inquiries regarding this Cookie Policy, please contact:<br />
                                Email: legal@autofoc.us
                            </p>
                        </section>
                    </motion.div>
                </div>
            </div>
        </div>
    )
}

export default Cookies 